import "core-js/modules/es6.string.link";

function getVideoShareInfo(info) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!info) {
    throw Error('【设置分享】缺少分享信息');
  }

  var infoSingleTitle = info.singleTitle,
      title = info.title,
      content = info.content,
      weiboContent = info.weiboContent,
      img = info.img,
      isShareImageOnly = info.isShareImageOnly,
      imgbase64 = info.imgbase64,
      _info$link = info.link,
      link = _info$link === void 0 ? window.location.href : _info$link,
      dokiId = info.dokiId;
  var defaultSingleTitle = infoSingleTitle || [title, content].join('。');
  var singleTitle = from === 'weibo' && weiboContent || defaultSingleTitle; // isShareImageOnly 代表是否传单图 而不是链接

  var shareConfig = {
    title: title,
    subTitle: content,
    singleTitle: singleTitle,
    content: content,
    contentTail: singleTitle,
    imageUrl: img,
    imgbase64String: isShareImageOnly ? imgbase64 : null,
    isShareImageOnly: !!isShareImageOnly,
    url: link,
    picList: [],
    // imgUrl, thumbUrl
    shareDokiInfo: {
      dokiId: "".concat(dokiId),
      shareContent: content,
      shareUrlInfo: {
        url: link,
        urlTitle: title,
        linkImgUrl: img
      }
    },
    dokiId: "".concat(dokiId),
    shareContent: content,
    shareUrlInfo: {
      url: link,
      urlTitle: title,
      linkImgUrl: img
    }
  };

  if (!shareConfig.isShareImageOnly) {
    delete shareConfig.imgbase64String;
  }

  return shareConfig;
}

var Share = {
  weixin: function weixin(info) {
    info = getVideoShareInfo(info);
    console.log('@@@@@Share2WeixinInfo:', info);
    TenvideoJSBridge.invoke('shareWeixinUser', info, function (ret) {
      console.log(ret);
    });
  },
  wxmoments: function wxmoments(info) {
    info = getVideoShareInfo(info);
    TenvideoJSBridge.invoke('shareWeixinTimeline', info, function (ret) {
      console.log(ret);
    });
  },
  doki: function doki(info) {
    var _info = info,
        dokiUrlText = _info.dokiUrlText;
    info = getVideoShareInfo(info);

    if (info.isShareImageOnly) {
      TenvideoJSBridge.invoke('saveImage', {
        imgbase64String: info.imgbase64String,
        needSaveToAlbum: false
      }, function (res) {
        try {
          res = JSON.parse(res);
        } catch (e) {
          void 0;
        }

        if (res.result && res.result.filePath) {
          info.shareDokiInfo.shareImageInfo = {
            imgUrl: res.result.filePath,
            linkUrl: info.url,
            linkUrlText: dokiUrlText || info.singleTitle
          };
          info.shareDokiInfo.shareContent = info.singleTitle;
          delete info.shareDokiInfo.shareUrlInfo;
        }

        TenvideoJSBridge.invoke('shareDoki', info, function (ret) {
          console.log(ret);
        });
      });
    } else {
      TenvideoJSBridge.invoke('shareDoki', info, function (ret) {
        console.log(ret);
      });
    }
  },
  qq: function qq(info) {
    // shareQQUser
    info = getVideoShareInfo(info);
    TenvideoJSBridge.invoke('shareQQUser', info, function (ret) {
      console.log(ret);
    });
  },
  qzone: function qzone(info) {
    // shareQzone
    info = getVideoShareInfo(info);
    TenvideoJSBridge.invoke('shareQzone', info, function (ret) {
      console.log(ret);
    });
  },
  weibo: function weibo(info) {
    // shareSinaWeibo
    info = getVideoShareInfo(info, 'weibo');
    TenvideoJSBridge.invoke('shareSinaWeibo', info, function (ret) {
      console.log(ret);
    });
  }
};
export default {
  openShare: function openShare(type, shareInfo) {
    Share[type] && Share[type](shareInfo);
  }
};